// Imports
import Vue from 'vue'
import Router from 'vue-router'

import {layout, redirect, route,} from '@/util/routes'
import store from "@/store";
import {AuthService} from "@/services";
import $const from "@/common/const";

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior: (to, from, savedPosition) => {
        if (to.hash) return {selector: to.hash}
        if (savedPosition) return savedPosition

        return {x: 0, y: 0}
    },
    routes: [
        layout('Default', [
                //Auto redirect to App list
                redirect('', 'applications'),

                // App List
                route('ApplicationList', null, 'applications'),

                //App Details
                layout('AppDetails', [
                    redirect('', 'settings'),
                    route('ApplicationSettings', null, 'settings'),
                    route('ApplicationLinkBot', null, 'link-bot'),
                    route('ApplicationWebhook', null, 'webhook')
                ], 'applications/:appId')
            ],
            '',
            {
                requiresAuth: true
            }
        ),
        route('AuthenticationComplete', null, '/authentication/complete', {requiresAuth: false})
    ],
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta['requiresAuth'])) {
        if (store.getters['auth/isLoggedIn']) {
            next()
            return
        }
        const providerStr = to.query.provider ? to.query.provider : 'fpt_id'
        const provider = AuthService.getProvider(providerStr)
        localStorage.setItem($const.LOCAL_STORAGE_KEY.PROVIDER, JSON.stringify(provider))
        store.dispatch('auth/signIn')
    }
    else {
        next()
    }
})

export default router
